<template>
    <div> 
        <Header :active="3" @show-contact="showContact" :title="'新闻动态'"></Header>
        <div class="banner">
            <img class="banner-pc" src="../assets/image/banner/banner_news.jpg"></img>
            <img class="banner-m" src="../assets/image/banner/banner_news_m.jpg"></img>
        </div>
        <div class="news-container-pc">
           <div class="news-container-title">
                <p class="title-pc" :class="{ active: activeCategory === 1 }" @click="getNewsList(1)">公司动态</p>
                <p class="title-pc" :class="{ active: activeCategory === 2 }" @click="getNewsList(2)">行业资讯</p>
            </div>
            <div class="line"></div>
            <div class="news-items" v-for="(news, index) in newsList" :key="index" @click="goToNewsDetail(news.id)">
                <img :src="baseUrl + news.imagePath" alt="news image">
                <div class="news-content">
                    <h2>{{ news.title }}</h2>
                    <p class="date">{{ news.publishDate.split(' ')[0] }}</p>
                    <p class="summary">{{ news.details.replace(/<[^>]*>/g, '') }}</p>
                </div>
            </div>
        </div>

        <div class="news-container-m" ref="scrollContainer">
            <div class="news-container-title">
                <p class="title-m" :class="{ active: activeCategory === 1 }" @click="getNewsList(1)">公司动态</p>
                <p class="title-m" :class="{ active: activeCategory === 2 }" @click="getNewsList(2)">行业资讯</p>
            </div>
            <div class="line"></div>
            <div class="news-items" v-for="(news, index) in items" :key="index" @click="goToNewsDetail(news.id)">
                <img :src="baseUrl + news.imagePath" alt="news image">
                <div class="news-content">
                    <h2>{{ news.title }}</h2>
                    <p class="date">{{ news.publishDate.split(' ')[0] }}</p>
                    <p class="summary">{{ news.details.replace(/<[^>]*>/g, '') }}</p>
                </div>
            </div>
        </div>
        <el-pagination
            style="margin: 0.15rem auto 1.21rem;width: 60%;display: flex;flex-direction: row;justify-content: center;"
            @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="pageId"
            :page-size="pageSize" :page-sizes="[5, 10, 20]" layout="sizes, prev, pager, next" :total="total">
        </el-pagination>
        <!-- 结尾 -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>
<script>
import { getNewsByType } from '../api/news'
import { baseUrl, uploadeImage } from '../api/images'
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
import Contact from '../components/Contact.vue'
import Email from '../components/Email.vue'
export default {
    name: 'News',
    data() {
        return {
            newsList: [],
            baseUrl: uploadeImage,
            isFixed: false,
            logo: baseUrl + 'logo.png',
            menu: baseUrl + 'menu.png',
            total: 10,
            pageId: 1,
            pageSize: 5,
            isContactVisible: false,
            activeCategory:1
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    created() {
        //创建组件的时候调用查询所有用户的方法
        this.getNewsList(1)
    },

    methods: {
        goToNewsDetail(id) {
            this.$router.push({ name: 'NewsDetail', params: { id } });
        },
        async getNewsList(type) {
            this.activeCategory = type;
            try {
                const params = {
                    // pageId: this.pageId,
                    // pageSize: this.pageSize,
                    type: this.activeCategory
                };
                const { data } = await getNewsByType(params);
                this.newsList = data.list || data; // 确保数据结构正确
                this.items = data.list || data; // 如果 items 也需要更新
            } catch (error) {
                console.error('Error fetching news:', error);
            }
        },
        handleCurrentChange(val) {
            this.pageId = val;
            this.getNewsList();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageId = 1;
            this.getNewsList();
        },
        showContact() {
            this.isContactVisible = true;
        },
        close() {
            this.isContactVisible = false;
        }
    }
}
</script>
<style scoped>
@import '../assets/css/newsStyle.css';
</style>